/**
 * Module-level token getter bridge between React Auth0 context
 * and non-React consumers (axios interceptor, MapLibre transformRequest).
 */

let _getTokenFn: (() => Promise<string | null>) | null = null;
let _cachedToken: string | null = null;

export const setTokenGetter = (fn: (() => Promise<string | null>) | null) => {
  _getTokenFn = fn;
};

export const getToken = async (): Promise<string | null> => {
  if (_getTokenFn) {
    const token = await _getTokenFn();
    _cachedToken = token;
    return token;
  }
  return null;
};

/**
 * Synchronous accessor for the last-resolved token.
 * Used by MapLibre's transformRequest (which cannot be async).
 * The token is kept fresh by every getToken() call (authedClient interceptor).
 */
export const getCachedToken = (): string | null => _cachedToken;
